export default __webpack_public_path__ + "static/media/email.14157efa.png";